import { useEffect, useState } from "react";

// STYLES
import * as Style from "./NewcomeUserStyle";

// LIBRARIES
import { useTranslation } from "react-i18next";

// MISC
import { COLORS } from "constants/styleVariables";
import {
  ModalTypes, NewcomeUserStatus
} from "models/GeneralTypes/generalTypes";
import { IProps } from "./NewcomeUserModel";

// ASSETS
import PersonDefaultIcon from "assets/Icons/defaultPersonPhoto.jpg";

// REDUX
import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import { language, toggleModalState } from "slices/uiSlice";

// COMPONENTS

const NewcomeUser = (props: IProps) => {
  // PROPS
  const { user = {} } = props;

  // CONSTANTS USING LIBRARIES
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const selectedLanguage = useAppSelector(language);

  // CONSTANTS USING HOOKS
  const [statusColor, setStatusColor] = useState<string>("");

  // GENERAL CONSTANTS

  // USE EFFECT FUNCTION
  useEffect(() => {
    if (user?.userStatus === NewcomeUserStatus.VERIFIED) {
      setStatusColor(COLORS.primaryGreen);
    } else {
      setStatusColor(COLORS.terraCotta);
    }
    //eslint-disable-next-line
  }, [user?.userStatus, selectedLanguage]);

  // REQUEST API FUNCTIONS

  // HANDLERS FUNCTIONS
  const handleOpen = () => {
    dispatch(
      toggleModalState({
        isVisible: true,
        type: ModalTypes.USER,
        user: user,
      })
    );
  };

  return (
    <Style.NewcomeUserContainer>
      <Style.VerticalLine />
      <Style.NewComeUserContent>
        <Style.ClickableContainer>
          <Style.UserImage src={user?.image || PersonDefaultIcon} />
          <Style.UserInfo>
            <Style.UserName>{user?.fullName || "NO_NAME_PROVIDED"}</Style.UserName>
            <Style.UserStatus>
              <Style.Dot color={statusColor} />
              <Style.StatusValue color={statusColor}>
                {t(`user.status.${user?.userStatus}`) || ""}
              </Style.StatusValue>
            </Style.UserStatus>
          </Style.UserInfo>
        </Style.ClickableContainer>
      </Style.NewComeUserContent>
    </Style.NewcomeUserContainer>
  );
};

export default NewcomeUser;
